import { Col, Container, Form, Row } from 'react-bootstrap';
import { ControlButtons } from '../ControlButtons';
import { Address } from '../FormFields/Address';
import { PhoneNumber } from '../FormFields/PhoneNumber';
import { useForm } from 'react-hook-form';

import { blastingInfoSchema } from '../../schemas/blastingInfoSchema';
import { yupResolver } from '@hookform/resolvers/yup';

export const BlastingInformation = ({
	blastingInfo = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const { register, handleSubmit, formState } = useForm({
		resolver: yupResolver(blastingInfoSchema),
		defaultValues: blastingInfo,
	});
	return (
		<Container className="component">
			<Container className="component mt-5">
				<h1>Blasting Company Information</h1>
				<Form.Group>
					<Form.Label>Business Name</Form.Label>
					<Form.Control type="text" {...register('businessName')} />
					<Form.Text className="text-danger">
						{formState.errors.businessName?.message}
					</Form.Text>
				</Form.Group>
				<Address register={register} error={formState.errors} />
				<Row>
					<Form.Group as={Col} xs="12" md="6">
						<Form.Label>Contact Person</Form.Label>
						<Form.Control type="text" {...register('contactPerson')} />
						<Form.Text className="text-danger">
							{formState.errors.contactPerson?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} xs="12" md="6">
						<Form.Label>Title</Form.Label>
						<Form.Control type="text" {...register('title')} />
						<Form.Text className="text-danger">
							{formState.errors.title?.message}
						</Form.Text>
					</Form.Group>
				</Row>
				<Row>
					<Form.Group as={Col} xs="12" md="6">
						<Form.Label>Office Phone:</Form.Label>
						<PhoneNumber register={register} error={formState.errors} />
						<Form.Text className="text-danger">
							{formState.errors.phone?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} xs="12" md="6">
						<Form.Label>After Hours Phone:</Form.Label>
						<PhoneNumber
							register={register}
							registerName="afterHourPhone"
							error={formState.errors}
						/>
						<Form.Text className="text-danger">
							{formState.errors.afterHourPhone?.message}
						</Form.Text>
					</Form.Group>
				</Row>
				<Row>
					<Form.Group as={Col} xs="12" md="6">
						<Form.Label>Business License Number</Form.Label>
						<Form.Control type="text" {...register('licenseNumber')} />
						<Form.Text className="text-danger">
							{formState.errors.licenseNumber?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} xs="12" md="6">
						<Form.Label>Jurisdiction</Form.Label>
						<Form.Control type="text" {...register('jurisdiction')} />
						<Form.Text className="text-danger">
							{formState.errors.jurisdiction?.message}
						</Form.Text>
					</Form.Group>
				</Row>
			</Container>
			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={onSubmit}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}
			/>
		</Container>
	);
};
